const prefix = `@@form-actions/`

const actionTypes = {
    GET_CUSTOM_REGIONS_START: `${prefix}GET_CUSTOM_REGIONS_START`,
    GET_CUSTOM_REGIONS_SUCCESS: `${prefix}GET_CUSTOM_REGIONS_SUCCESS`,
    GET_CUSTOM_REGIONS_FAIL: `${prefix}GET_CUSTOM_REGIONS_FAIL`,
}

export default actionTypes

export const getCustomRegionTypes = {
    start: actionTypes.GET_CUSTOM_REGIONS_START,
    success: actionTypes.GET_CUSTOM_REGIONS_SUCCESS,
    fail: actionTypes.GET_CUSTOM_REGIONS_FAIL,
}
